import React, { FC, useMemo } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { makeChartOptions } from "./utils";

type Props = {
  data: [number, number][];
};

const BucketSizeChart: FC<Props> = ({ data }) => {
  const options = useMemo(() => makeChartOptions(data), [data]);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default BucketSizeChart;
